module.exports = __webpack_public_path__ + "static/media/Wagstaff_Portrait.7d82d34c.png";